import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import moment from "moment";
import {
  ApproveButton,
  CancelButton,
  RejectButton,
  SaveAndUpdate,
} from "../../utils/commonComponent/Custom/Button";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";
import Subtypes, { SUBTYPE_OPTIONS } from "./subtypes";
import AppConfirmBox from "../../utils/commonComponent/appConfirmBox";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FlagIcon from "@mui/icons-material/Flag";
import PartiallyDisbursedHistory from "./partiallyDisbursedHistory";

const EditRequirement = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({
    date: new Date(),
    priority: "Regular",
  });
  const [subtypesData, setSubtypesData] = React.useState([]);
  const [oldSubtypesData, setOldSubtypesData] = React.useState([]);
  const [allEmployees, setAllEmployees] = React.useState([]);
  const [employeeDetails, setEmployeeDetails] = React.useState([]);
  const [jobDetails, setJobDetails] = React.useState({});
  const [deletedIds, setDeletedIds] = React.useState([]);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [dialogProps, setDialogProps] = React.useState({});
  const [remark, setRemark] = React.useState("");
  const [openAmendmentModal, setOpenAmendmentModal] = React.useState(false);
  const [amendmentHistory, setAmendmentHistory] = React.useState([]);
  const [openDisbursedHistory, setOpenDisbursedHistory] = React.useState(false);
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const [subTypes, setSubTypes] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [amount, setAmount] = React.useState("");
  const remarkRef = useRef("");

  const hasRedFlag = subtypesData?.some((row) => row.redFlagStatus === 1);

  const saveDisabledCon =
    !(
      // L1 can act when l1Status is 0
      (
        (permissions.l1 && inputStates?.l1Status === 0) ||
        // HOD can act only after L1 completed (disabled if hasRedFlag)
        (!hasRedFlag &&
          permissions.hod &&
          jobDetails?.projectHodId === _employeeId &&
          inputStates?.l1Status === 1 &&
          inputStates?.hodStatus === 0 &&
          inputStates?.h1Status === 0 &&
          inputStates?.h2Status === 0) ||
        // HOD who is also the requester can act when hasRedFlag is true
        (permissions.hod &&
          inputStates?.requesterId == _employeeId &&
          hasRedFlag &&
          inputStates?.hodStatus === 0 &&
          inputStates?.h1Status === 0 &&
          inputStates?.h2Status === 0) ||
        // H1 can act only after L1 completed (disabled if hasRedFlag)
        (!hasRedFlag &&
          permissions.h1 &&
          inputStates?.l1Status === 1 &&
          inputStates?.h1Status === 0 &&
          inputStates?.h2Status === 0) ||
        // H2 can act only after L1 completed (disabled if hasRedFlag)
        (!hasRedFlag &&
          permissions.h2 &&
          inputStates?.l1Status === 1 &&
          inputStates?.h2Status === 0) ||
        // Other roles (no hasRedFlag restriction)
        (!permissions.l1 &&
          !permissions.hod &&
          !permissions.h1 &&
          !permissions.h2 &&
          hasRedFlag)
      )
    ) && params.id != 0;

  const notRequster =
    (permissions.l1 && inputStates?.requesterId != _employeeId) ||
    (permissions.hod &&
      jobDetails?.projectHodId == _employeeId &&
      inputStates?.requesterId != _employeeId) ||
    (permissions.h1 && inputStates?.requesterId != _employeeId) ||
    (permissions.h2 && inputStates?.requesterId != _employeeId);



  const inputFields = [
    {
      type: "Autocomplete",
      label: "Requirement Type *",
      stateKey: "requirmentType",
      options: [
        { id: 1, name: "Advance" },
        { id: 2, name: "Reimbursement" },
        { id: 3, name: "10 Days Advance" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: saveDisabledCon || notRequster,
    },

    {
      type: "Autocomplete",
      label: "Job Number *",
      stateKey: "jobId",
      options: "jobRegister",
      valueKey: "id",
      getOptionLabelKey: "jobNumber",
      disabled: saveDisabledCon || notRequster,
    },
    {
      type: "Autocomplete",
      label: "Priority *",
      stateKey: "priority",
      options: [
        { id: 1, name: "Regular" },
        { id: 2, name: "High" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: saveDisabledCon || notRequster,
    },

    {
      type: "Textarea",
      label: "Requester Name *",
      stateKey: "requesterName",
      disabled: true,
    },
    {
      type: "Textarea",
      label: "Department * ",
      stateKey: "department",
      disabled: true,
    },

    {
      type: "Textarea",
      label: "Site Name",
      stateKey: "siteName",
      disabled: true,
    },
    {
      type: "DatePicker",
      label: "Created Date",
      stateKey: "date",
      disabled: true,
    },
    ...(inputStates.requirmentType === "10 Days Advance"
      ? [
          {
            type: "DatePicker",
            label: "From Date",
            stateKey: "fromDate",
            disabled: saveDisabledCon || notRequster,
          },
          {
            type: "DatePicker",
            label: "To Date",
            stateKey: "toDate",
            disabled: saveDisabledCon || notRequster,
          },
        ]
      : []),
    // Conditionally render ImageUpload field
    ...(inputStates.requirmentType === "Reimbursement"
      ? [
          {
            type: "ImageUpload",
            stateKey: "attachmentUlr",
            label: "Attachments",
            disabled: saveDisabledCon || notRequster,
           
          },
        ]
      : []),
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchRequirementDetails = async () => {
    try {
      const [requirement] = await fetchQuery(
        `SELECT * FROM requirements WHERE id = ${params.id}`,
      );
      setInputStates(requirement);
    } catch (error) {
      console.error("Error fetching Requirement data:", error);
    }
  };

  const fetchSubtypesDetails = async () => {
    try {
      const Subtypes = await fetchQuery(
        `SELECT rp.*, rp.remarks AS remark, r.requesterId 
      FROM requirementPrices rp
      LEFT JOIN requirements r ON r.id = ${params.id}
      WHERE rp.status = 1 AND rp.requirementId = ${params.id}`,
      );

      setSubtypesData([...Subtypes]);
      setOldSubtypesData(JSON.parse(JSON.stringify(Subtypes)));
    } catch (error) {
      console.error("Error fetching Subtypes data:", error);
    }
  };

  const fetchAllEmployees = async () => {
    try {
      const Employee = await fetchQuery(
        `SELECT id, name, employeesCode FROM employees WHERE status=1 `,
      );
      setAllEmployees(Employee);
    } catch (error) {
      console.error("Error fetching Employee data:", error);
    }
  };

  const fetchEmployeeDetails = async (_employeeId) => {
    try {
      const [employee] = await fetchQuery(`
      SELECT e.*, eod.hrDesignation, eod.department
      FROM employees e
      LEFT JOIN employeeOtherData eod 
        ON e.id = eod.employeeId
      WHERE e.id = ${_employeeId}
    `);

      setEmployeeDetails(employee);
    } catch (error) {
      console.error("Error fetching Employee data:", error);
    }
  };

  const deleteRequirementPrices = async () => {
    try {
      if (deletedIds.length > 0) {
        await fetchQuery(
          `UPDATE requirementPrices SET status = -1 WHERE id IN (${deletedIds.join(",")}) `,
        );
      }
    } catch (error) {
      console.error("Soft delete failed:", error);
    }
  };

  const saveRequirementPrices = async (requirementId) => {
    try {
      if (!subtypesData?.length) return true;

      const rowsForUpdate = [];
      const rowsForCreate = [];

      subtypesData.forEach((row) => {
        const { requesterId, remark, ...rowWithout } = row;
        const payload =
          (permissions.l1 && inputStates?.requesterId != _employeeId) ||
          (permissions.hod &&
            jobDetails?.projectHodId === _employeeId &&
            inputStates?.requesterId != _employeeId) ||
          // (permissions.hod && inputStates.requesterId == _employeeId) ||
          (permissions.h1 && inputStates?.requesterId != _employeeId) ||
          (permissions.h2 && inputStates?.requesterId != _employeeId)
            ? {
                requirementId,
                amount: row.amount,
                id: row.id,
                redFlagStatus: row.redFlagStatus,
                redFlagDetails: row.redFlagDetails,
                remarks: remark,
                description:row.description,
                subTypes:row.subTypes
                
              }
            : {
                ...rowWithout,
                remarks: remark,
                requirementId,
                ...(_employeeId == inputStates.requesterId
                  ? {
                      redFlagStatus: 0,
                      redFlagDetails: "",
                    }
                  : {
                      redFlagStatus: row.redFlagStatus,
                      redFlagDetails: row.redFlagDetails,
                    }),
              };

        row.id ? rowsForUpdate.push(payload) : rowsForCreate.push(payload);
      });

      await Promise.all([
        rowsForUpdate.length &&
          axiosWithToken.patch(
            `${BASE_URL}bulk/requirementPrices`,
            rowsForUpdate,
          ),
        rowsForCreate.length &&
          axiosWithToken.post(
            `${BASE_URL}requirementPrices/bulk`,
            rowsForCreate,
          ),
      ]);

      return true;
    } catch (error) {
      console.error("Requirement Prices submission failed:", error);
      toast.error("Failed to save requirement prices");
      return false;
    }
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      { value: inputStates.date, label: "Date is required" },
      {
        value: inputStates.requirmentType,
        label: "Requirment Type is required",
      },
      { value: inputStates.jobId, label: "Job Number is required" },
      { value: inputStates.priority, label: "Priority is required" },
      { value: inputStates.requesterId, label: "Requested Name is required" },
      // { value: inputStates.department, label: "Department is required" },
      ...(inputStates.requirmentType === "Reimbursement"
        ? [
            {
              value: inputStates.attachmentUlr,
              label:
                "Attachment is required when Requirement Type is Reimbursement",
            },
          ]
        : []),
    ];

    if (!validateRequiredFields(fieldsToValidate)) return;

    const hasValidSubtype = (subtypesData || []).every((obj) => {
      const subTypes = obj?.subTypes;
      const amount = obj?.amount;
      const description = obj?.description;

      const isValidSubType =
        subTypes !== undefined && subTypes !== null && subTypes !== "";
      const isValidAmount =
        amount !== undefined && amount !== null && amount !== "";
      //  &&
      // Number(amount) !== 0;
      const isValidDescription =
        description !== undefined && description !== null && description !== "";

      return isValidSubType && isValidAmount && isValidDescription;
    });

    if (!hasValidSubtype) {
      toast.error(
        "Each subtype must have a valid subType, amount, and description.",
      );
      return;
    }

    const canAmend =
      subtypesData?.length > 0 &&
      (permissions.l1 ||
        (permissions.hod && jobDetails?.projectHodId === _employeeId) ||
        (permissions.hod && inputStates.requesterId == _employeeId) ||
        permissions.h1 ||
        permissions.h2);

    const hasChangedRows =
  canAmend &&
  (subtypesData || []).some((newRow) => {
    const oldRow = oldSubtypesData?.find((o) => o.id === newRow.id);
    return (
      oldRow &&
      (
        Number(oldRow.amount) !== Number(newRow.amount) ||
        oldRow.subTypes !== newRow.subTypes ||
        oldRow.description !== newRow.description
      )
    );
  });

    if (hasChangedRows) {
      setRemark("");
      setOpenConfirm(true);
      setDialogProps({
        title: "Reason for  Changes",
        showRemark: true,
        confirmText: "Continue",
        onConfirm: () => {
          setOpenConfirm(false);
          submitForm(remarkRef.current);
        },
      });
      return; // ⛔ wait for remark
    }

    await submitForm(""); // no changes, skip remark
  };

  const submitForm = async (remark) => {
    const totalAmount = (subtypesData || []).reduce(
      (sum, { amount }) => sum + (Number(amount) || 0),
      0,
    );

    const canAmend =
      subtypesData?.length > 0 &&
      (permissions.l1 ||
        (permissions.hod && jobDetails?.projectHodId === _employeeId) ||
        (permissions.hod && inputStates.requesterId == _employeeId) ||
        permissions.h1 ||
        permissions.h2);

    const changedRows = (subtypesData || []).filter((newRow) => {
      const oldRow = oldSubtypesData?.find((o) => o.id === newRow.id);
      return oldRow && Number(oldRow.amount) !== Number(newRow.amount);
    });

    const amendmentDetails = canAmend
      ? [
          inputStates?.amendmentDetails ||
            oldSubtypesData
              ?.map(
                (row) =>
                  `${row.id}|${row.requesterId}|${row.amount}|${
                    row.createdOn || new Date(inputStates?.date).toISOString()
                  }| Created |${row.subTypes}|${row.description}`,
              )
              .join(","),

       changedRows
          .map((row) => {
            const base = `${row.id}|${_employeeId}|${row.amount}|${new Date().toISOString()}${remark ? `|${remark}` : ""} |${row.subTypes}|${row.description}`;

            return base;
          })
          .join(","),
        ]
          .filter(Boolean)
          .join(",")
      : inputStates?.amendmentDetails || "";

    const l1RedFlagUpdate = permissions.l1 && {
      redFlagStatus: subtypesData.some((i) => i.redFlagStatus === 1) ? 1 : 0,
      redFlagDetails: subtypesData
        .map((item, i) =>
          item.redFlagDetails?.trim()
            ? `${i + 1}. ${item.redFlagDetails.trim()}`
            : null,
        )
        .filter(Boolean)
        .join(", "),
    };

    try {
      const url = BASE_URL + `requirements`;
      let requirementId = params.id;

      const { requesterName, siteName, ...payload } = inputStates;

      const requestData = {
        ...payload,
        date: moment(inputStates.date).format("YYYY-MM-DD HH:mm:ss"),
        totalAmount,
      };

      if (params.id !== "0") {
        await axiosWithToken.patch(`${url}/${params.id}`, {
          ...requestData,
          ...(_employeeId == inputStates.requesterId && {
            redFlagStatus: 0,
            redFlagDetails: "",
          }),
          ...l1RedFlagUpdate,
          ...(canAmend && {
            amendmentStatus: 1,
            amendmentDetails,
          }),
        });
      } else {
        const res = await axiosWithToken.post(url, requestData);
        requirementId = res.data.insertId;
      }

      const priceSaved = await saveRequirementPrices(requirementId);
      if (!priceSaved) return;

      await deleteRequirementPrices();

      toast.success(
        params.id !== "0"
          ? "Requirement Updated Successfully!"
          : "Requirement Created Successfully!",
      );

      setTimeout(() => {
        params.id == 0
          ? navigate("/requirementList")
          : window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  const handleApprove = () => {
    setDialogProps({
      title: "Do you really want to Approve this?",
      showRemark: false,
      confirmText: "Approve",
      confirmColor: "success",
      onConfirm: async () => {
        const payload = {};

        if (permissions.l1) {
          payload.l1Status = 1;
          payload.l1Id = _employeeId;
        }
        if (permissions.hod && jobDetails?.projectHodId == _employeeId) {
          payload.hodStatus = 1;
          payload.hodId = _employeeId;
        }
        if (permissions.h1) {
          payload.h1Status = 1;
          payload.h1Id = _employeeId;
        }
        if (permissions.h2) {
          payload.h2Status = 1;
          payload.h2Id = _employeeId;
        }

        await axiosWithToken.patch(
          `${BASE_URL}requirements/${params.id}`,
          payload,
        );

        // window.location.reload();
        navigate("/requirementList");
      },
    });

    setOpenConfirm(true);
  };

  const handleReject = () => {
    setDialogProps({
      title: "Enter Rejection Remark",
      showRemark: true,
      confirmText: "Reject",
      confirmColor: "error",
      onConfirm: async (finalRemark) => {
        const payload = { rejectionReason: finalRemark };

        if (permissions.l1) {
          payload.l1Status = 2;
        }
        if (permissions.hod && jobDetails?.projectHodId == _employeeId) {
          payload.hodStatus = 2;
        }
        if (permissions.h1) {
          payload.h1Status = 2;
        }
        if (permissions.h2) {
          payload.h2Status = 2;
        }

        await axiosWithToken.patch(
          `${BASE_URL}requirements/${params.id}`,
          payload,
        );

        // window.location.reload();
        navigate("/requirementList");
      },
    });

    setOpenConfirm(true);
  };

  const handleRedFlag = () => {
    setDialogProps({
      title: "Enter Red Flag Reason",
      showRemark: true,
      confirmText: "Confirm",
      confirmColor: "warning",
      onConfirm: async (finalRemark) => {
        await axiosWithToken.patch(`${BASE_URL}requirements/${params.id}`, {
          ...(permissions.l1 && { redFlagStatus: 1 }),
          redFlagDetails: finalRemark,
        });

        setOpenConfirm(false);
        window.location.reload();
      },
    });

    setOpenConfirm(true);
  };

  const fetchJobRegisterDetails = async (jobId) => {
    if (!jobId) return;

    try {
      const [job] = await fetchQuery(
        `SELECT * FROM jobRegister WHERE id = ${jobId}`,
      );
      setJobDetails(job); // make sure you have this state
    } catch (error) {
      console.error("Error fetching Job Register data:", error);
    }
  };

  const buildAmendmentHistory = () => {
    if (!inputStates?.amendmentDetails) return [];

    // 1️⃣ Create flat array
    const flatData = inputStates.amendmentDetails.split(",").map((item) => {
      const [id, employeeId, amount, dateTime, remark,subTypes, description] = item.split("|");

      const employee = allEmployees?.find((emp) => emp.id == employeeId);

      const subtypeRow = subtypesData?.find((row) => row.id == id);

      return {
        id,
        employeeName: employee
          ? `${employee.name} (${employee.employeesCode})`
          : employeeId,
        subTypes: subTypes || subtypeRow?.subTypes ,
        description: description || subtypeRow?.description,
        amount,
        dateTime, // grouping key
        remark,
      };
    });

    // 2️⃣ Group by dateTime + srNo per group
    return Object.values(
      flatData.reduce((acc, item) => {
        const key = item.dateTime;

        if (!acc[key]) {
          acc[key] = [];
        }

        acc[key].push({
          ...item,
          srNo: acc[key].length + 1,
        });

        return acc;
      }, {}),
    );
  };

  const handleDisbursed = (row) => {
    setDialogProps({
      title: "Confirm Disbursement",
      showRemark: false,
      confirmText: "Confirm",
      confirmColor: "success",
      onConfirm: async () => {
        await axiosWithToken.patch(`${BASE_URL}requirements/${row.id}`, {
          ...(permissions.l2 && { disbursedStatus: 1 }),
        });

        setOpenConfirm(false);
        window.location.reload();
      },
    });

    setOpenConfirm(true);
  };

  const handlePartiallyDisbursed = (row) => {
    const alreadyDisbursed = row.disbursedDetails
      ? JSON.parse(row.disbursedDetails).reduce(
          (sum, item) => sum + Number(item.amount),
          0,
        )
      : 0;

    const remainingAmount = Number(row.totalAmount) - alreadyDisbursed;

    const uniqueSubTypes = [
      ...new Set(subtypesData?.map((item) => item.subTypes)),
    ];

    setDialogProps({
      title: "Enter Partially Disbursed Details",
      showRemark: true,
      showAmount: false,
      showSubTypes: false,
      subTypeOptions: uniqueSubTypes,
      maxAmount: remainingAmount,
      confirmText: "Confirm",
      confirmColor: "success",
      onConfirm: async (finalRemark, finalAmount, finalSubTypes) => {
        const prevDetails = row.disbursedDetails
          ? JSON.parse(row.disbursedDetails)
          : [];

        const updatedDetails = [
          ...prevDetails,
          ...selectedRows.map((row) => ({
            remark: finalRemark,
            amount: row.amount,
            subTypes: row.subTypes, // or row.subTypes.join(", ") if it's an array
            date: new Date().toISOString(),
            id: row.id,
          })),
        ];

        await axiosWithToken.patch(`${BASE_URL}requirements/${row.id}`, {
          ...(permissions.l2 && {
            disbursedDetails: JSON.stringify(updatedDetails),
            disbursedStatus: 2,
          }),
        });

        setOpenConfirm(false);
        window.location.reload();
      },
    });

    setSubTypes([]); // reset before opening
    setOpenConfirm(true);
  };

  useEffect(() => {
    const result = buildAmendmentHistory();
    setAmendmentHistory(result);
  }, [inputStates, allEmployees, subtypesData]);

  useEffect(() => {
    if (inputStates?.requesterId) {
      fetchEmployeeDetails(inputStates?.requesterId);
    }
  }, [inputStates?.requesterId]);

  useEffect(() => {
    if (inputStates?.jobId) {
      fetchJobRegisterDetails(inputStates.jobId);
    }
  }, [inputStates?.jobId]);

  useEffect(() => {
    setInputStates((prev) => ({
      ...prev,
      requesterId:
        params.id == 0 && _employeeId ? _employeeId : prev.requesterId,
      department: employeeDetails?.department,
      requesterName: employeeDetails?.name,
      siteName: jobDetails?.siteName,
    }));
  }, [_employeeId, employeeDetails, jobDetails]);

  useEffect(() => {
    if (params.id != 0) {
      fetchRequirementDetails();
      fetchSubtypesDetails();
    }
    fetchAllEmployees();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Requirement" : `Update Requirement `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <hr />
      <Subtypes
        subtypesData={subtypesData}
        setSubtypesData={setSubtypesData}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        permissions={permissions}
        inputStates={inputStates}
        saveDisabledCon={saveDisabledCon}
        notRequster={notRequster}
        hasRedFlag={hasRedFlag}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
      <br />
      <div className="mt-5 flex flex-col gap-4 md:flex-row md:justify-between md:items-center">
        {/* LEFT SIDE – Approve / Reject / Red Flag / Amendment History */}
        <div className="flex flex-wrap gap-3">
          {/* Approve & Reject — with detailed tooltip logic */}
          {(permissions.l1 ||
            (permissions.hod && jobDetails?.projectHodId == _employeeId) ||
            (permissions.hod &&
              inputStates.requesterId == _employeeId &&
              jobDetails?.projectHodId == _employeeId) ||
            permissions.h1 ||
            permissions.h2) &&
            params.id != 0 && (
              <>
                <Tooltip
                  title={
                    [
                      inputStates?.l1Status,
                      inputStates?.hodStatus,
                      inputStates?.h1Status,
                      inputStates?.h2Status,
                    ].includes(2)
                      ? "Requirement already rejected"
                      : inputStates?.h2Status === 1
                        ? "Requirement already approved"
                        : permissions.l1 && inputStates?.l1Status !== 0
                          ? "L1 has already taken action"
                          : permissions.hod && inputStates?.hodStatus !== 0
                            ? "HOD has already taken action"
                            : permissions.h1 && inputStates?.h1Status !== 0
                              ? "H1 has already taken action"
                              : permissions.h2 && inputStates?.h2Status !== 0
                                ? "H2 has already taken action"
                                : ""
                  }
                >
                  <span>
                    <ApproveButton
                      label="Approve"
                      className="w-full sm:w-auto"
                      disabled={
                        hasRedFlag ||
                        inputStates?.redFlagStatus == 1 ||
                        [
                          inputStates?.l1Status,
                          inputStates?.hodStatus,
                          inputStates?.h1Status,
                          inputStates?.h2Status,
                        ].includes(2) ||
                        (permissions.l1 &&
                          (inputStates?.l1Status !== 0 ||
                            inputStates?.hodStatus !== 0 ||
                            inputStates?.h1Status !== 0 ||
                            inputStates?.h2Status !== 0)) ||
                        (permissions.hod &&
                          (inputStates?.hodStatus !== 0 ||
                            inputStates?.l1Status !== 1 ||
                            inputStates?.h1Status !== 0 ||
                            inputStates?.h2Status !== 0)) ||
                        (permissions.h1 &&
                          (inputStates?.h1Status !== 0 ||
                            inputStates?.l1Status == 0 ||
                            inputStates?.h2Status !== 0)) ||
                        (permissions.h2 &&
                          (inputStates?.h2Status !== 0 ||
                            inputStates?.l1Status == 0))
                      }
                      onClick={handleApprove}
                    />
                  </span>
                </Tooltip>

                <Tooltip
                  title={
                    [
                      inputStates?.l1Status,
                      inputStates?.hodStatus,
                      inputStates?.h1Status,
                      inputStates?.h2Status,
                    ].includes(2)
                      ? "Requirement already rejected"
                      : inputStates?.h2Status === 1
                        ? "Requirement already approved"
                        : permissions.l1 && inputStates?.l1Status !== 0
                          ? "L1 has already taken action"
                          : permissions.hod && inputStates?.hodStatus !== 0
                            ? "HOD has already taken action"
                            : permissions.h1 && inputStates?.h1Status !== 0
                              ? "H1 has already taken action"
                              : permissions.h2 && inputStates?.h2Status !== 0
                                ? "H2 has already taken action"
                                : ""
                  }
                >
                  <span>
                    <RejectButton
                      label="Reject"
                      className="w-full sm:w-auto"
                      disabled={
                        hasRedFlag ||
                        inputStates?.redFlagStatus == 1 ||
                        [
                          inputStates?.l1Status,
                          inputStates?.hodStatus,
                          inputStates?.h1Status,
                          inputStates?.h2Status,
                        ].includes(2) ||
                        (permissions.l1 &&
                          (inputStates?.l1Status !== 0 ||
                            inputStates?.hodStatus !== 0 ||
                            inputStates?.h1Status !== 0 ||
                            inputStates?.h2Status !== 0)) ||
                        (permissions.hod &&
                          (inputStates?.hodStatus !== 0 ||
                            inputStates?.l1Status !== 1 ||
                            inputStates?.h1Status !== 0 ||
                            inputStates?.h2Status !== 0)) ||
                        (permissions.h1 &&
                          (inputStates?.h1Status !== 0 ||
                            inputStates?.l1Status == 0 ||
                            inputStates?.h2Status !== 0)) ||
                        (permissions.h2 &&
                          (inputStates?.l1Status == 0 ||
                            inputStates?.h2Status !== 0))
                      }
                      onClick={handleReject}
                    />
                  </span>
                </Tooltip>
              </>
            )}

          {/* Amendment History */}
          {inputStates?.amendmentDetails && (
            <button
              onClick={() => setOpenAmendmentModal(true)}
              className="w-full sm:w-auto rounded-md px-3 py-2 bg-blue-600 text-white hover:bg-blue-700"
            >
              Amendment History
            </button>
          )}

          {/* Disbursed & Partially Disbursed — tooltip is just the button name */}
          {permissions.l2 && (
            <>
              <Tooltip title="Disbursed">
                <span>
                  <button
                    onClick={() => handleDisbursed(inputStates)}
                    disabled={
                      inputStates.disbursedStatus === 1 ||
                      inputStates?.h2Status !== 1
                    }
                    className={`rounded-md px-3 py-2 text-white ${
                      inputStates.disbursedStatus === 1 ||
                      inputStates?.h2Status !== 1
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    Disbursed
                  </button>
                </span>
              </Tooltip>

              <Tooltip title="Partially Disbursed">
                <span>
                  <button
                    onClick={() => handlePartiallyDisbursed(inputStates)}
                    disabled={
                      !selectedRows ||
                      selectedRows.length === 0 ||
                      inputStates?.h2Status !== 1 ||
                      inputStates.disbursedStatus === 1 ||
                      (inputStates.disbursedDetails &&
                        JSON.parse(inputStates.disbursedDetails).reduce(
                          (sum, item) => sum + Number(item.amount),
                          0,
                        ) >= Number(inputStates.totalAmount))
                    }
                    className={`rounded-md px-3 py-2 text-white ${
                      !selectedRows ||
                      selectedRows.length === 0 ||
                      inputStates?.h2Status !== 1 ||
                      inputStates.disbursedStatus === 1 ||
                      (inputStates.disbursedDetails &&
                        JSON.parse(inputStates.disbursedDetails).reduce(
                          (sum, item) => sum + Number(item.amount),
                          0,
                        ) >= Number(inputStates.totalAmount))
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    Partially Disbursed
                  </button>
                </span>
              </Tooltip>
            </>
          )}

          {/* Disbursed History */}
          {inputStates.disbursedDetails && (
            <button
              onClick={() => setOpenDisbursedHistory(true)}
              className="rounded-md px-3 py-2 text-white bg-purple-600 hover:bg-purple-700"
            >
              Disbursed History
            </button>
          )}
        </div>

        {/* RIGHT SIDE – Cancel / Save */}
        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            className="w-full sm:w-auto"
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />

          {(permissions.save || permissions.allAccess) && (
            <SaveAndUpdate
              id="btn-add-outline"
              label={params.id == 0 ? "Save" : "Update"}
              className="w-full sm:w-auto"
              onClick={onSubmit}
              disabled={saveDisabledCon}
            />
          )}
        </div>
      </div>

      <br />
      <AppConfirmBox
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        remark={remark}
        setRemark={(val) => {
          setRemark(val);
          remarkRef.current = val;
        }}
        amount={amount}
        setAmount={setAmount}
        subTypes={subTypes}
        setSubTypes={setSubTypes}
        {...dialogProps}
      />

      <Dialog
        open={openAmendmentModal}
        onClose={() => setOpenAmendmentModal(false)}
        maxWidth="md"
        fullWidth
      >
        {/* TITLE + CLOSE ICON */}
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pr: 2,
          }}
        >
          Amendment History
          <IconButton
            onClick={() => setOpenAmendmentModal(false)}
            sx={{ color: "red" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {amendmentHistory.length > 0 ? (
            amendmentHistory.map((group, groupIndex) => (
              <Box key={groupIndex} mb={3}>
                <TableContainer
                  component={Paper}
                  sx={{
                    border: "1px solid #e5e7eb",
                    boxShadow: "none",
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#f9fafb" }}>
                        <TableCell sx={{ fontWeight: 600 }}>Sr.No</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Employee Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Sub Type</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Description
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Amount</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Remark</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Date & Time
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {group.map((row, rowIndex) => {
                        const dateObj = new Date(row.dateTime);

                        const formattedDate =
                          dateObj.toLocaleDateString("en-GB");

                        const formattedTime = dateObj.toLocaleTimeString(
                          "en-US",
                          {
                            hour: "numeric",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          },
                        );

                        return (
                          <TableRow key={rowIndex}>
                            <TableCell>{row.srNo}</TableCell>
                            <TableCell>{row.employeeName}</TableCell>
                            <TableCell>{row.subTypes}</TableCell>
                            <TableCell>{row.description}</TableCell>
                            <TableCell>{row.amount}</TableCell>
                            <TableCell>{row.remark}</TableCell>
                            <TableCell>
                              {formattedDate} {formattedTime}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ))
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Amendment History Found
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>

      <PartiallyDisbursedHistory
        open={openDisbursedHistory}
        onClose={() => setOpenDisbursedHistory(false)}
        disbursedDetails={inputStates?.disbursedDetails}
      />
    </div>
  );
};

export default EditRequirement;
